module.exports = __webpack_public_path__ + "assets/SquareAboutCircle.526e0a3e62ba15b6aa045d50b3aa252a.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/SquareAboutCircle.gmt
// module id = 996
// module chunks = 0